module.exports = __webpack_public_path__ + "img/CUANDO.1cf44b4a.png";